module.exports = __webpack_public_path__ + "static/img/26.b2c32d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/26.png
// module id = +dnP
// module chunks = 1